import { DialogType } from '@/enums/dialogType'
import api from '@/services/api'

export default {
    namespaced: true,
    state: {
        pot: {},
        lstPot: [],
        isUpdate: false,
        shouldReload: false,
        search: "",
        itemsPerPage: 25,
        hasNext: false,
        page: 1,
        totalItems: 0,
        headers: [
            { title: 'Pote', key: 'potName', align: 'center' }
        ],
    },
    getters: {
        getPot(state) {
            let pot = { ...state.pot }
            return pot
        }
    },
    mutations: {
        setPot(state, pot) {
            state.pot = pot
        },
        setLstPot(state, lstPot) {
            state.lstPot = lstPot
        },
        appendLstPot(state, items) {
            state.lstPot = [...state.lstPot, ...items]
        },
        clearLstPot(state) {
            state.lstPot = []
        },
        setPage(state, page) {
            state.page = page
        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setTotalItems(state, total) {
            state.totalItems = total
        },
        setShouldReload(state, reload) {
            state.shouldReload = reload
        },
        initForm(state) {
            state.isUpdate = false
            state.pot = {}
            state.search = ''
        },
        setUpdating(state) {
            state.isUpdate = true
        }
    },
    actions: {
        async save({ state, dispatch }) {
            if (state.isUpdate) {
                return await dispatch('update')
            }
            else
                return await dispatch('insert')
        },

        async insert({ getters, dispatch }) {
            await api.post(
                '/Pot/Insert',
                getters.getPot
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Pote salvo'
            }, { root: true })

            return true
        },

        async update({ getters, dispatch }) {
            await api.put(
                '/Pot/Update',
                getters.getPot
            )

            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Pote atualizado'
            }, { root: true })

            return true
        },

        async search({ state, commit }, { search, limit = 25, page = 1, reset}) {
            let searchParam = search || state.search
            const response = await api.get(
                `/Pot/Search?search=${searchParam}&limit=${limit}&page=${page}`
            )

            if (reset) {
                commit("setLstPot", response.data.items)
            } else {
                commit("appendLstPot", response.data.items)
            }

            commit('setHasNext', response.data.hasNext)
            commit('setTotalItems', response.data.totalCount)
            commit('setPage', page)

            return true
        },

        async find({ commit }, potId) {
            const response = await api.get(
                `/Pot/Find/${potId}`,
            )
            commit('setPot', response.data)
            commit('setUpdating')

            return true
        },

        async findAll({ commit }) {
            const response = await api.get(
                `/Pot/FindAll/`,
            )
            commit('setLstPot', response.data)
            
            return true
        },

        async delete({ getters, dispatch }) {
            await api.delete(
                `/Pot/Delete/${getters.getPot.potId}`,
            )
            dispatch('systemDialog/show', {
                type: DialogType.SUCCESS,
                message: 'Registro deletado com sucesso!'
            }, { root: true })

            return true
        }
    }
}